module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_200.454e1b49.csv";